import axiosClient from "api/axiosClient";
import IAPIResponse from "interfaces/IAPIResponse";
import IMerchant from "interfaces/IMerchant";
import CustomError from "providers/CustomError";
import axios from "axios";
import { API_BASE_URL, HTTP_STATUS_CODES } from "configs";

const MerchantRepository = {
    getById: async (merchantId: number): Promise<IMerchant> => {
        try {
            const response = await axiosClient.get<IAPIResponse<IMerchant>>(`/giftCardSite/Merchant/${merchantId}`);
            const { codeNumber, data, message } = response.data;
            if (codeNumber === HTTP_STATUS_CODES.OK) return data;
            throw new CustomError(message, codeNumber);
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    getByGuid: async (guid: string): Promise<IMerchant> => {
        try {
            const response = await axios.get<IAPIResponse<IMerchant>>(`/giftcardsite/Merchant/guid/${guid}`, {
                baseURL: API_BASE_URL,
            });
            const { codeNumber, data, message } = response.data;
            if (codeNumber === HTTP_STATUS_CODES.OK) return data;
            throw new CustomError(message, codeNumber);
        } catch (error) {
            throw error;
        }
    },
};

export default MerchantRepository;
